import { render, staticRenderFns } from "./StraightTab.vue?vue&type=template&id=748a3192&scoped=true&"
import script from "./StraightTab.vue?vue&type=script&lang=js&"
export * from "./StraightTab.vue?vue&type=script&lang=js&"
import style0 from "./StraightTab.vue?vue&type=style&index=0&id=748a3192&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748a3192",
  null
  
)

export default component.exports